module.exports = __webpack_public_path__ + "img/Zak_Khutoretsky.b4ddcc37.jpg";